import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// component
import { LoadingScreen } from "../../component/loading";
import { routePublict } from "./route/router_publict";
import { routerPrivate } from "./route/router_private";
import { useLogged } from "hook/useLogged";

// redux

const Router = () => {
  // -------------------------- STATE ---------------------------
  const { logged } = useLogged();
  // -------------------------- REDUX ---------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- MAIN ----------------------------
  if (logged === null) {
    return <LoadingScreen />;
  }
  return (
    <BrowserRouter>
      <Routes>
        {logged ? routerPrivate() : routePublict()}
        <Route path="*" element={<Navigate to={"/"} exact replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
